import React from "react";
import { motion } from "framer-motion";
import { Button } from "./ui/button";

/**
 * Floating toolbar to toggle between wireframe and solid view
 */
function FloatingToolbar({
  showWireframe,
  setShowWireframe,
}: {
  showWireframe: boolean;
  setShowWireframe: (show: boolean) => void;
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-50"
    >
      <Button onClick={() => setShowWireframe(!showWireframe)} variant={showWireframe ? "default" : "secondary"}>
        {showWireframe ? (
          <img
            src="/solid-cube.png"
            alt=""
            className="w-4 h-4"
          />
        ) : (
          <img
            src="/wireframe-icon.png"
            alt=""
            className="w-4 h-4"
          />
        )}
        {showWireframe ? "Solid" : "Wireframe"}
      </Button>
    </motion.div>
  );
}

export default FloatingToolbar; 
